import { encounterCreatureField, inventoryField, itemsCol, layerOf, scalarLayerSlot } from '../../shared/array-types';
import { readInventoryPossessorType } from '../compile/inventory-environment';
import type { ItemFieldRow } from '../compile/item-field-reader';

/** Display only. The existing book activity bridge owns the reading/history verdict. */
export function hasBookReadingMechanics(book: unknown): boolean {
    const amount = layerOf(book, 'reading_time_int'), unit = layerOf(book, 'reading_time_type');
    return amount != null && String(amount) !== '' && unit != null && String(unit) !== '';
}

export function isBookPcCaster(caster: unknown): boolean {
    const row = caster as { player_characters?: unknown; encounter_creatures?: unknown } | null;
    return !!itemsCol(row?.player_characters, 'item_id')
        && !!encounterCreatureField(row?.encounter_creatures, 'encounter_creature_id');
}

export function objectCardGatherKind(item: ItemFieldRow | null, integrated: boolean): 'gather' | 'dig' | null {
    if (!inventoryField(item, 'inventory_id')) return null;
    const roll = scalarLayerSlot(layerOf(item, 'roll_type')).toUpperCase();
    if (roll !== 'FA17A3A2-3068-C84C-1EA5-C511F71FBD8B' && roll !== 'E1C8D281-0DC7-4883-8381-5630E23AD99D') return null;
    const possessor = readInventoryPossessorType(item);
    if (possessor === null) return null;
    if (['player_character', 'encounter_creature', 'creature'].includes(possessor)
        && !(itemsCol(item, 'item_type') === 'monster_bit' && integrated)) return null;
    return roll === 'E1C8D281-0DC7-4883-8381-5630E23AD99D' ? 'dig' : 'gather';
}
